import React from 'react'
import PropTypes from 'prop-types'
import Select, { components } from 'react-select'
import * as R from 'ramda'
import Option from './Option'

const defaultLanguage = { value: 'en', label: 'English' }

const languages = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
  { value: 'fr', label: 'French' },
  { value: 'es', label: 'Spanish' },
  { value: 'it', label: 'Italian' },
  { value: 'nl', label: 'Dutch' },
  { value: 'pt', label: 'Portuguese' },
]

const byLabel = R.comparator((a, b) => a.label < b.label);
const sortLanguage = R.sort(byLabel, languages);

const CustomOption = ({ innerProps, data }) => {
  return (
    <div {...innerProps}>
      <Option data={data} />
    </div>
  )
}

const Control = ({ children, ...props }) => {
  const currentValue = props.selectProps.value
  return (
    <components.Control {...props}>
      <Option data={currentValue} withText={false} />
      {children}
    </components.Control>
  );
};


const customStyles = {
  singleValue: (provided, state) => ({
    display: state.selectProps.menuIsOpen ? 'none' : 'block',
  })
}

const LanguageSelect = ({ selected, onChange }) => {
  return (
    <div style={{width: '200px'}} className='mt-3 mb-3 me-3'>
      <Select
        styles={customStyles}
        value={selected}
        isSearchable={true}
        options={sortLanguage}
        onChange={onChange}
        components={{
          Option: CustomOption,
          Control: Control
        }}
      />
    </div>
  )
}

export default LanguageSelect
export {
  defaultLanguage
}

LanguageSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired
}
